var _rect, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#83a77a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18,1A17,17,0,0,0,5.979,30.021,17,17,0,0,0,30.021,5.979,16.889,16.889,0,0,0,18,1m0-1A18,18,0,1,1,0,18,18,18,0,0,1,18,0Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.191,0C16.28,0,18,1.78,18,4.83h0V15.16c0,3.1-1.72,4.84-4.809,4.84H4.81C1.77,20,0,18.26,0,15.16H0V4.83C0,1.78,1.77,0,4.81,0h8.381ZM5.08,13.74a.784.784,0,0,0-.75.37.8.8,0,0,0,0,.84.777.777,0,0,0,.75.36h7.84a.79.79,0,0,0,0-1.57H5.08Zm7.84-4.561H5.08a.781.781,0,0,0,0,1.561h7.84a.781.781,0,0,0,0-1.561ZM8.069,4.65H5.08v.01a.78.78,0,1,0,0,1.56H8.069a.785.785,0,0,0,0-1.57Z",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.972b08181e5e71559ae3f29c0121b0d8.svg";
export { ForwardRef as ReactComponent };